import React from 'react';
import { InjectedRouter } from 'react-router';
import { Location } from 'history';

import CoachingViewHeader from 'coaching/components/CoachingViewHeader';

import TabPanel from 'components/TabPanel';
import Tabs from 'components/Tabs';
import EventTracking from 'lib/EventTracking';

import 'coaching/components/styles/CoachingHomeTabContainer.scss';

export interface Tab {
  title: string;
  element: JSX.Element;
  route: string;
  clickEventKey?: string;
  viewEventKey?: string;
  eventProperties?: Object;
}

export type Props = {
  title: string;
  tabs: Tab[];
  renderAllTabs: boolean;
  location: Location;
  router: InjectedRouter;
  isCoach?: boolean;
};

export const coachingHomeEventPrefix = 'coaching.coaching_home_dashboard';

export default function CoachingHomeTabView(props: Props) {
  const { title, tabs, renderAllTabs, location, router, isCoach } = props;

  return (
    <div className="CoachingHomeTabContainer">
      <CoachingViewHeader
        imageSize={16}
        textSize="small"
        isTabbed
        title={title}
        helpButtonEventKey={`${coachingHomeEventPrefix}.get_help.click`}
        isCoach={isCoach}
      />
      <Tabs
        buttonColor="paper"
        buttonSize="xsmall"
        type="border"
        tabActive={determineActiveTabFromPath(tabs, location, router)}
        onTabChange={i => {
          const { clickEventKey, viewEventKey, route } = tabs[i];
          if (clickEventKey) {
            EventTracking.trackKey(clickEventKey);
          }
          if (viewEventKey) {
            EventTracking.trackKey(viewEventKey);
          }
          router.push(route);
        }}
        renderAllTabs={renderAllTabs}>
        {tabs.map(({ title, element }) => {
          return (
            <TabPanel
              className="CoachingHomeTabContainer-tab"
              title={<span>{title}</span>}
              key={title}>
              {element}
            </TabPanel>
          );
        })}
      </Tabs>
    </div>
  );
}

function determineActiveTabFromPath(
  tabs: Tab[],
  location: Location,
  router: InjectedRouter
): number {
  const index = tabs.findIndex(tab => location.pathname.startsWith(tab.route));
  if (index >= 0) {
    return index;
  }

  // If no match - set path to first tab
  router.push(tabs[0].route);
  return 0;
}
